import PropTypes from "prop-types";

/**
 * Read-only TipTap / ProseMirror HTML.
 * Styling matches `.common-text-editor .ProseMirror` in `index.css` (class `.rich-text-display`)
 * so paragraphs, headings, lists, tables, code blocks, blockquotes, links, media, and task lists
 * render like the editor. Inline styles saved in HTML (font, color, text-align, etc.) still apply.
 */
export default function RichTextDisplay({ html = "", className = "" }) {
  if (!html || !html.trim()) return null;

  return (
    <div
      className={["rich-text-display", className].filter(Boolean).join(" ")}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

RichTextDisplay.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
};
